/*
  Sharpen Swatch King's COLLECTION swatches (product cards).

  The app requests each card swatch from Shopify's CDN at a fixed 48x48
  (`&width=48&height=48&crop=top`). ecofuego-custom.css now draws those
  swatches at 36px, which a 2x screen renders from 72 device pixels — so the
  48px file would be upscaled and soft.

  This keeps the app's framing exactly (same crop, same square aspect) and
  only raises the requested size to 144x144. It is NOT the PDP un-crop
  (ecofuego-swatch-uncrop.js), which removes the crop; card swatches keep it.

  Guarded three ways: only `.swatches-type-collections .star-set-image`, only
  Shopify CDN URLs, and only when the URL already carries both width and
  height. If the app changes its markup the selector stops matching and the
  swatches fall back to the app's own 48px images — nothing else breaks.

  Swatch King injects cards' swatch markup after load, so a body-level
  childList observer (no attribute watching — our own writes can't retrigger
  it) plus two late sweeps.
*/
(function () {
  'use strict';

  var SELECTOR = 'variant-swatch-king .swatches-type-collections .star-set-image';
  var SIZE = '144';

  function sharpen(el) {
    if (el.getAttribute('data-ef-res') === SIZE) return;
    var bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage;
    if (!bg || bg.indexOf('http') === -1) return;

    var raw = bg.slice(bg.indexOf('http')).replace(/["')\s]+$/, '');
    var url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (e) {
      return;
    }
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url.href)) return;
    if (!url.searchParams.has('width') || !url.searchParams.has('height')) return;

    url.searchParams.set('width', SIZE);
    url.searchParams.set('height', SIZE);
    el.style.setProperty('background-image', 'url("' + url.href + '")', 'important');
    el.setAttribute('data-ef-res', SIZE);
  }

  function sweep() {
    var found = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) sharpen(found[i]);
  }

  function start() {
    sweep();
    if (typeof MutationObserver === 'undefined') return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        sweep();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(sweep, 800);
  setTimeout(sweep, 2500);
})();
